export const mergeAudioBlobs = async (audioBlobs: Blob[]): Promise<Blob> => {
    const audioContext = new AudioContext()
    console.log('>>> 3')
    // Decode each blob into AudioBuffer
    const decodedBuffers = await Promise.all(
        audioBlobs.map(async (blob) => {
            const arrayBuffer = await blob.arrayBuffer()
            return await audioContext.decodeAudioData(arrayBuffer)
        })
    )
    console.log('>>> 11')
    if (decodedBuffers.length === 0) throw new Error('No audio buffers to merge.')

    const numChannels = decodedBuffers[0].numberOfChannels
    const sampleRate = decodedBuffers[0].sampleRate
    const totalLength = decodedBuffers.reduce((sum, buffer) => sum + buffer.length, 0)
    console.log('>>> 17')
    // Create a new buffer to hold all merged data
    const mergedBuffer = audioContext.createBuffer(numChannels, totalLength, sampleRate)
    console.log('>>> 20')
    let offset = 0
    for (const buffer of decodedBuffers) {
        for (let channel = 0; channel < numChannels; channel++) {
            mergedBuffer.getChannelData(channel).set(buffer.getChannelData(channel), offset)
        }
        offset += buffer.length
    }
    console.log('>>> 28')

    // Encode to WAV
    const wavBlob = encodeWAV(mergedBuffer)
    console.log('>>> 31')
    return wavBlob
}

export async function saveBlobWithFileSystemAPI(blob: Blob, filename: string) {
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = filename

    // Append, click, and remove
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // Revoke the URL after download
    URL.revokeObjectURL(url)
    return
}

export const encodeWAV = (audioBuffer: AudioBuffer): Blob => {
    const numChannels = audioBuffer.numberOfChannels
    const sampleRate = audioBuffer.sampleRate
    const format = 1 // PCM
    const bitDepth = 16

    const samples = audioBuffer.length
    const blockAlign = (numChannels * bitDepth) / 8
    const byteRate = sampleRate * blockAlign
    const dataSize = samples * blockAlign
    const buffer = new ArrayBuffer(44 + dataSize)
    const view = new DataView(buffer)

    let offset = 0
    console.log('>>> 101')
    const writeString = (str: string) => {
        for (let i = 0; i < str.length; i++) {
            view.setUint8(offset++, str.charCodeAt(i))
        }
    }

    const writeInt16 = (output: Float32Array, inputOffset: number) => {
        for (let i = 0; i < output.length; i++, inputOffset++) {
            let s = Math.max(-1, Math.min(1, output[i]))
            s = s < 0 ? s * 0x8000 : s * 0x7fff
            view.setInt16(offset, s, true)
            offset += 2
        }
    }
    console.log('>>> 116')
    // WAV header
    writeString('RIFF')
    view.setUint32(offset, 36 + dataSize, true)
    offset += 4
    writeString('WAVE')
    writeString('fmt ')
    view.setUint32(offset, 16, true)
    offset += 4
    view.setUint16(offset, format, true)
    offset += 2
    view.setUint16(offset, numChannels, true)
    offset += 2
    view.setUint32(offset, sampleRate, true)
    offset += 4
    view.setUint32(offset, byteRate, true)
    offset += 4
    view.setUint16(offset, blockAlign, true)
    offset += 2
    view.setUint16(offset, bitDepth, true)
    offset += 2
    writeString('data')
    view.setUint32(offset, dataSize, true)
    offset += 4
    console.log('>>> 140')
    // Interleave and write PCM samples
    const interleaved = new Float32Array(samples * numChannels)
    for (let sampleIndex = 0; sampleIndex < samples; sampleIndex++) {
        console.log(samples, sampleIndex)
        for (let channel = 0; channel < numChannels; channel++) {
            console.log(numChannels, channel)
            interleaved[sampleIndex * numChannels + channel] =
                audioBuffer.getChannelData(channel)[sampleIndex]
        }
    }

    writeInt16(interleaved, 0)
    console.log('>>> 151')
    return new Blob([view], { type: 'audio/wav' })
}

export const getAudioDurationFromBlob = async (blob: Blob): Promise<number> => {
    const arrayBuffer = await blob.arrayBuffer()
    const audioContext = new AudioContext()
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
    console.log('??', audioBuffer.duration)
    return audioBuffer.duration // in seconds
}
